import React from "react";
import { Controller, useFormContext } from "react-hook-form";

interface FormCheckboxProps {
  name: string;
  label?: string;
  optionLabel?: string;
  required?: boolean;
  disabled?: boolean;
  className?: string;
  validation?: any;
  size?: "small" | "medium" | "large";
  noGap?: boolean;
  checked?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const FormCheckbox: React.FC<FormCheckboxProps> = ({
  name,
  label,
  optionLabel,
  required = false,
  disabled = false,
  className = "",
  validation,
  size = "medium",
  noGap = false,
  onChange,
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const error = errors[name];

  const sizeClass =
    size === "small"
      ? "custom-control-sm"
      : size === "large"
      ? "custom-control-lg"
      : "custom-control-md";

  return (
    <>
      <Controller
        name={name}
        control={control}
        rules={{
          required: required ? "This field is required" : false,
          ...validation,
        }}
        render={({ field }) => (
          <div
            className={`custom-control custom-checkbox ${sizeClass} ${
              noGap ? "noGap" : ""
            } ${className}`}
          >
            <input
              type="checkbox"
              className="custom-control-input"
              id={`${name}-switch`}
              checked={field.value || false}
              onChange={(e) => {
                field.onChange(e.target.checked);
                onChange?.(e);
              }}
              disabled={disabled}
            />
            <label className="custom-control-label" htmlFor={`${name}-switch`}>
              {optionLabel}
            </label>
            {error && (
              <div className="invalid-feedback">{error.message as string}</div>
            )}
          </div>
        )}
      />
    </>
  );
};

export default FormCheckbox;
